const currency = {
  numberToCurrency: value => {
    if (isNaN(value)){
      return value;
    }
    return value
      .toFixed(2)
      .replace(".", ",")
      .replace(/\d(?=(\d{3})+,)/g, "$&.");
  },
  objNumberToCurrency: obj => {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        obj[prop] = currency.numberToCurrency(obj[prop]);
      }
    }
    return obj;
  },
  currencyToNumber: value => {
    if (!isNaN(value)){
      return value;
    }
    if (value.length === 0) {
      return 0;
    }
    const number = value
      .split(".")
      .join("")
      .replace(",", ".");
    return isNaN(number) ? NaN : parseFloat(number);
  },
  shiftComma: (str, pos) => {
    const strArray = str.split("");
    const commaIndex = strArray.indexOf(",");
    strArray.splice(commaIndex, 1);
    strArray.splice(commaIndex + pos, 0, ",");
    return strArray.join("");
  },
  numberToPercentage: value => {
    if (isNaN(value)){
      return value;
    }
    return `${value} %`.replace(".", ",");
  }
};
export default currency;
